export const AUTHORIZATION_HEADER_KEY = "Authorization";
export const STATUS_ONLINE = "ONLINE";
export const STATUS_DELETED = "DELETED";
export const STATUS_TO_BE_RELEASED = "TO_BE_RELEASED";
export const ALEA_PLAY_OPERATOR_ID = process.env.REACT_APP_ALEA_PLAY_OPERATOR_ID;
export const REACT_APP_ALEA_PLAY_CASINO_DUMMY_ID = process.env.REACT_APP_ALEA_PLAY_CASINO_DUMMY_ID;

export enum Status {
  DELETED = "DELETED",
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  IN_DRAFT = "IN_DRAFT",
  IN_MAINTENANCE = "IN_MAINTENANCE",
}

export enum GameStatus {
  DELETED = "DELETED",
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  IN_MAINTENANCE = "IN_MAINTENANCE",
}

export enum GameConfigurationStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  IN_DRAFT = "IN_DRAFT",
  IN_MAINTENANCE = "IN_MAINTENANCE",
}

export enum GameReleaseStatus {
  ONLINE = "ONLINE",
  READY = "READY",
  COMING_SOON = "COMING_SOON",
  TO_BE_RELEASED = "TO_BE_RELEASED",
  DISABLED = "DISABLED",
  IN_MAINTENANCE = "IN_MAINTENANCE",
  DECOMMISSIONED = "DECOMMISSIONED",
}

export enum GameRolloutStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  IN_DRAFT = "IN_DRAFT",
  IN_MAINTENANCE = "IN_MAINTENANCE",
  PRE_RELEASED = "PRE_RELEASED",
}

export enum Sort {
  DESC = "desc",
  ASC = "asc",
}

export enum SortBy {
  NAME = "name",
}

export enum GameCategoryType {
  GENRE = "GENRE",
  INVOICING = "INVOICING",
  JACKPOT = "JACKPOT",
}

export enum TitleTag {
  H1 = "h1",
  H2 = "h2",
}

export const ThumbnailCollectionOptions = [
  { label: "Long Screen | 5:3 | 500x300", value: "RATIO_5_3" },
  { label: "Miniature | 1:1 | 100x100", value: "RATIO_1_1" },
  { label: "Panoramic | 4:2 | 400x200", value: "RATIO_4_2" },
  { label: "Portrait | 3:4 | 300x400", value: "RATIO_3_4" },
  { label: "Portrait XL | 2:4 | 200x400", value: "RATIO_2_4" },
  { label: "Screen | 4:3 | 400x300", value: "RATIO_4_3" },
  { label: "Screen XL | 3:2 | 600x400", value: "RATIO_3_2" },
  { label: "Square | 4:4 | 400x400", value: "RATIO_4_4" },
  { label: "Big Square | 6:6 | 600x600", value: "RATIO_6_6" },
];

export enum ThumbnailSource {
  CUSTOM = "CUSTOM",
  GENERIC = "GENERIC",
}

export enum ThumbnailQuality {
  ORIGINAL = "ORIGINAL",
  HIGH = "HIGH",
  WEBP = "WEBP",
  WEBM = "WEBM",
}

export const ImplementedAPIs = [
  { label: "Bonus API - Bet Win Bonus Free Spin", value: "BONUS_API_BET_WIN_BONUS_FS" },
  { label: "Bonus API - Promo Payout", value: "BONUS_API_PROMO_PAYOUT" },
  { label: "Launch API - V1", value: "LAUNCH_API_V1" },
  { label: "Launch API - V2", value: "LAUNCH_API_V2" },
  { label: "Launch API - V3", value: "LAUNCH_API_V3" },
  { label: "Customer API - Games List", value: "CUSTOMER_API_GAMES_LIST" },
  { label: "Customer API - Free Spin Available", value: "CUSTOMER_API_FREE_SPINS_CURRENCIES" },
  { label: "Customer API - Live Tables Available", value: "CUSTOMER_API_TABLE_GAMES" },
  { label: "Customer API - Round Display", value: "CUSTOMER_API_ROUND_DISPLAY" },
  { label: "Live Stream", value: "LIVE_STREAM" },
  { label: "Transaction API - End Round", value: "END_ROUND" },
];

export const noValueSelectOptions = [
  { label: "No value", value: "null" },
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];

export const defaultSelectOptions = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];

export const PaymentEntity = {
  OVERSEAS_EUR: "OVERSEAS_EUR",
  OVERSEAS_USD: "OVERSEAS_USD",
  MALTA: "MALTA",
  BRAZIL: "BRAZIL",
} as const;

export type PaymentEntity = (typeof PaymentEntity)[keyof typeof PaymentEntity];

export enum JackpotAccess {
  YES = "YES",
  SANDBOX = "SANDBOX",
  NO = "NO",
}

export enum UserRoles {
  ADMINISTRATOR = "ADMINISTRATOR",
}

export enum UserRoles {
  OWNER = "OWNER",
}

export const OWNER_ROLE = UserRoles.OWNER;

/**
 * Free-spin synchronization capability, exposed on the integrator.
 */
export enum FreeSpinSyncSupportStatus {
  NO_VALUE = "NO_VALUE",
  NOT_SUPPORTED = "NOT_SUPPORTED",
  SUPPORTED = "SUPPORTED",
  IMPLEMENTED = "IMPLEMENTED",
}

export enum FreeSpinSyncScope {
  NOT_APPLICABLE = "NOT_APPLICABLE",
  GLOBAL = "GLOBAL",
  PER_SKIN = "PER_SKIN",
}

export enum Versions {
  BETA = "beta",
}

export enum TasksType {
  CURREN_MAPPING_EDIT_IN_BULK = "CurrentMappingEditInBulk",
  TEST_RELEASE_EMAIL = "TestReleaseEmailTask",
}

export enum Permissions {
  OPERATOR_EMAIL_READ = "OPERATOR_EMAIL_READ",
  OPERATOR_EMAIL_WRITE = "OPERATOR_EMAIL_WRITE",
  ROLE_PERMISSIONS_READ = "ROLE_PERMISSIONS_READ",
}

export enum TypeNewsletter {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
}

export enum TasksTypes {
  DAILY_RELEASE_EMAIL = "DAILY_RELEASE_EMAIL",
  WEEKLY_RELEASE_EMAIL = "WEEKLY_RELEASE_EMAIL",
}

export const ONE_MINUTE = 60 * 1000;

export const ONE_HOUR = 60 * ONE_MINUTE;

export const ONE_DAY = 24 * ONE_HOUR;
export const THREE_DAYS = 3 * ONE_DAY;
export const THREE_MONTHS = 90 * ONE_DAY;
export const SIX_MONTHS = 180 * ONE_DAY;
export const THIRTY_ONE_DAYS = 31 * ONE_DAY;
export const TasksLinksType = ["DAILY_RELEASE_EMAIL", "WEEKLY_RELEASE_EMAIL"];

export const LINK_TO_NEW_CMS = "https://workspace.aleaplay.com/";
